import { useFeatureGate } from '@trello/feature-gate-client';

export const useIsPersistedProposedEventsEnabled = () => {
  const { value: isPersistedProposedEventsEnabled } = useFeatureGate(
    'phx_persisted_proposed_events',
  );
  return isPersistedProposedEventsEnabled;
};
